import './css/main.scss';
import { isLoginFirebase } from "./apis/firebaseAuthentication";
import { Mode } from "./constant/applicationConstant";
import { initRouter } from "./router/router";
// ルーター機能を統合した初期化関数
const initializeApp = async () => {
    // ルーターを初期化（これによって適切なページが自動的に表示される）
    initRouter();
};
// インポートした初期処理の関数を引数で渡して、Firebase認証成功時は呼び出しを行う
isLoginFirebase(Mode.MAIN, initializeApp);
